<div class="flex h-full w-full items-center justify-center">
  <app-spinner [size]="size()" />
</div>
